import React from "react";
import GoogleMapReact from "google-map-react";
import marker from "../../assets/icons/location-pin-svgrepo-com.png";
import "./Map.css";

const AnyReactComponent = ({ text }) => (
  <div className="map-marker">
    <img src={marker} alt="marker" />
  </div>
);

export default function Map({ lat, lang, setlatLang }) {
  const defaultProps = {
    center: {
      lat: 10.99835602,
      lng: 77.01502627,
    },
    zoom: 15,
  };

  const Click = ({ x, y, lat, lng, event }) => {
    console.log(x, y, lat, lng, event);
    setlatLang({ lat: lat, lng: lng });
  };

  return (
    // Important! Always set the container height explicitly
    <div style={{ height: "60vh", width: "100%" }}>
      <GoogleMapReact
        defaultCenter={defaultProps.center}
        onClick={Click}
        center={[lat, lang]}
        defaultZoom={defaultProps.zoom}
        language={"en"}
        region={"PK"}
      >
        <AnyReactComponent lat={lat} lng={lang} text="My Marker" />
      </GoogleMapReact>
    </div>
  );
}
